// ProCalories storefront behaviour. Pricing shown here comes from the same
// engine the ledger runs (pc-pricing.js); the server recomputes everything.
import { priceWeek, suggestBox, autoBox, defaultSplit } from './pc-pricing.js';

const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => [...r.querySelectorAll(s)];
const DATA = JSON.parse($('#pc-data')?.textContent || '{}');
const RULES = DATA.rules || {};
const ITEMS = Object.fromEntries((DATA.items || []).map((i) => [i.id, i]));
const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
document.documentElement.classList.add('pc-js'); // reveal animations only while this script runs
export const cad = (c) => `CAD ${(c / 100).toFixed(2)}`;

/* ---------- global: nav, dialogs, reveal, rails ---------- */
const nav = $('[data-nav]');
if (nav) {
  const onScroll = () => nav.classList.toggle('is-stuck', scrollY > 8);
  addEventListener('scroll', onScroll, { passive: true }); onScroll();
}
const opener = new WeakMap();
export function openDialog(d, from) {
  if (!d) return;
  opener.set(d, from || document.activeElement);
  d.showModal();
}
document.addEventListener('click', (e) => {
  const o = e.target.closest('[data-open]');
  if (o) openDialog(document.getElementById(o.dataset.open), o);
  const c = e.target.closest('[data-close]');
  if (c) c.closest('dialog')?.close();
});
document.addEventListener('close', (e) => {
  if (e.target.tagName === 'DIALOG') opener.get(e.target)?.focus?.();
}, true);
document.addEventListener('click', (e) => { // click on backdrop closes
  if (e.target.tagName === 'DIALOG' && (e.target.classList.contains('sheet') || e.target.classList.contains('drawer'))) {
    const r = e.target.getBoundingClientRect();
    if (e.clientY < r.top || e.clientY > r.bottom || e.clientX < r.left || e.clientX > r.right) e.target.close();
  }
});

if (!reduced && 'IntersectionObserver' in window) {
  const io = new IntersectionObserver((es) => es.forEach((en) => {
    if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
  }), { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  $$('.reveal').forEach((el) => io.observe(el));
} else $$('.reveal').forEach((el) => el.classList.add('is-in'));

$$('[data-rail-ctrl]').forEach((ctrl) => {
  const track = $(`#${ctrl.dataset.railCtrl} .rail__track`);
  const [prev, next] = $$('button', ctrl);
  const sync = () => {
    prev.disabled = track.scrollLeft <= 4;
    next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
  };
  ctrl.addEventListener('click', (e) => {
    const b = e.target.closest('button'); if (!b) return;
    track.scrollBy({ left: Number(b.dataset.dir) * track.clientWidth * 0.8, behavior: reduced ? 'auto' : 'smooth' });
  });
  track.addEventListener('scroll', sync, { passive: true }); sync();
});

/* ---------- meal detail sheet ---------- */
function describe(item) {
  const [main, sides] = item.name.split(' with ');
  if (!sides) return `${main}.`;
  return `${main}, served with ${sides.replace(/ & /g, ' and ').toLowerCase()}.`;
}
function tierChip(t) {
  if (t === 'premium') return '<span class="tier tier--premium">Premium</span>';
  if (t === 'standard') return '<span class="tier">Standard</span>';
  return '';
}
export function showMeal(id, from, action) {
  const item = ITEMS[id]; const d = $('#meal-sheet');
  if (!item || !d) return;
  const img = $('[data-sheet-img]', d);
  if (item.img2x) { img.src = item.img2x; img.alt = item.alt; img.hidden = false; } else img.hidden = true;
  $('[data-sheet-title]', d).textContent = item.name;
  $('[data-sheet-tier]', d).innerHTML = tierChip(item.tier);
  let copy = describe(item);
  if (item.channel === 'subscription') copy += item.tier === 'premium' ? ' A Premium meal: it uses one of your weekly Premium meals, then CAD 3.50 extra.' : ' A Standard meal: always included in your plan.';
  if (item.nutritionVerified && item.kcal) copy += ` ${item.kcal} kcal · ${item.protein} g protein per serving.`;
  $('[data-sheet-copy]', d).textContent = copy;
  const act = $('[data-sheet-action]', d); act.innerHTML = ''; if (action) act.append(action);
  openDialog(d, from);
}
document.addEventListener('click', (e) => {
  const b = e.target.closest('[data-detail]');
  if (b && !b.closest('[data-app]')) showMeal(b.dataset.detail, b);
});

/* ---------- cart helpers ---------- */
async function cartAdd(items) {
  const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
  if (!r.ok) throw new Error((await r.json().catch(() => ({}))).description || 'Could not add to cart');
  return r.json();
}
async function cartClear() { await fetch('/cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } }); }
export const cart = { add: cartAdd, clear: cartClear };

$$('[data-add-variant]').forEach((b) => b.addEventListener('click', async () => {
  b.disabled = true;
  try { await cartAdd([{ id: Number(b.dataset.addVariant), quantity: 1 }]); location.href = '/cart'; } catch (err) { b.disabled = false; alert(err.message); }
}));

/* ---------- menu page filters ---------- */
const filters = $('[data-filters]');
if (filters) {
  const grid = $('[data-grid]');
  filters.addEventListener('click', (e) => {
    const f = e.target.closest('[data-filter]');
    if (f) {
      $$('[data-filter]', filters).forEach((x) => x.setAttribute('aria-pressed', String(x === f)));
      const v = f.dataset.filter;
      $$('.meal', grid).forEach((m) => { m.hidden = !(v === 'all' || m.dataset.tier === v || m.dataset.category === v || m.dataset.goal === v); });
    }
    const v = e.target.closest('[data-view]');
    if (v) {
      $$('[data-view]', filters).forEach((x) => x.setAttribute('aria-pressed', String(x === v)));
      grid.classList.toggle('is-list', v.dataset.view === 'list');
    }
  });
}

/* ---------- time formatting (business timezone is the authority) ---------- */
export function fmtDate(ms, opts = {}) {
  return new Intl.DateTimeFormat('en-CA', { timeZone: RULES.timezone || 'America/Toronto', weekday: 'short', month: 'short', day: 'numeric', ...opts }).format(new Date(ms));
}
export function fmtDateTime(ms) {
  return fmtDate(ms, { hour: 'numeric', minute: '2-digit', timeZoneName: 'short' });
}

/* ---------- plan signup ---------- */
// Chef's Choice default for a new customer: alternate Premium and Standard;
// suggestBox caps Premium at the free allowance, so it never costs extra.
function chefTemplate(availability) {
  const ids = (t) => Object.values(ITEMS).filter((i) => availability.has(i.id) && i.channel === 'subscription' && i.tier === t).map((i) => i.id);
  const [p, s] = [ids('premium'), ids('standard')]; const out = [];
  for (let i = 0; i < Math.max(p.length, s.length); i++) { if (p[i]) out.push(p[i]); if (s[i]) out.push(s[i]); }
  return out;
}
const signup = $('[data-signup]');
if (signup) import('./pc-time.js').then(({ nextSlot, addLocalWeeks, pickDeliveryDay, WEEKDAY_NAMES }) => {
  const params = new URLSearchParams(location.search);
  const want = params.get('plan');
  // Phones: the next step sits below all four plan cards, so a plan choice scrolls to it.
  signup.addEventListener('change', (e) => {
    if (e.target.name !== 'plan' || !matchMedia('(max-width: 860px)').matches) return;
    const next = $('[data-next-step]', signup);
    if (next) { next.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' }); next.focus({ preventScroll: true }); }
  });
  if (want) { const r = $(`input[name="plan"][value="${CSS.escape(want)}"]`, signup); if (r) r.checked = true; }
  // Signed out: plans and prices only; meals, address and checkout come after the account exists.
  if (!DATA.customer) {
    const link = $('[data-account-link]', signup); const label = $('[data-account-plan]', signup);
    const sync = () => {
      const sel = $('input[name="plan"]:checked', signup);
      $$('.plan', signup).forEach((p) => p.classList.toggle('plan--rec', p.dataset.plan === sel?.value));
      $$('.plan label.btn', signup).forEach((l) => { const on = l.querySelector('input').checked; l.classList.toggle('btn--lime', on); l.classList.toggle('btn--ghost', !on); });
      if (!link) return;
      const back = `/pages/plans${sel ? `?plan=${encodeURIComponent(sel.value)}` : ''}`;
      link.href = `${window.PC_ROUTES?.login || '/account/login'}?return_to=${encodeURIComponent(back)}`;
      label.textContent = sel ? `Plan: ${RULES.plans?.[sel.value]?.name || sel.value}` : 'Plan: choose one above';
    };
    signup.addEventListener('change', sync); sync();
    signup.addEventListener('submit', (e) => e.preventDefault());
    return;
  }
  const ex = new Set();
  $('[data-exclusions]', signup).addEventListener('click', (e) => {
    const b = e.target.closest('[data-ex]'); if (!b) return;
    const on = b.getAttribute('aria-pressed') !== 'true';
    b.setAttribute('aria-pressed', String(on)); on ? ex.add(b.dataset.ex) : ex.delete(b.dataset.ex);
  });
  // Plan checkout is decided by the ledger service (gate + /apps/procalories/api/checkout).
  // In test mode only tagged test customers see an open checkout; the public never does.
  const gate = DATA.gate;
  const tester = !!(gate?.allowedTag && DATA.customer?.tags?.includes(gate.allowedTag));
  const gateOpen = !!(gate?.open && (gate.mode === 'live' || tester));
  const slots = gateOpen ? gate.slots || [] : RULES.primaryDeliverySlots || [];
  const twoRunsOk = gateOpen && !!gate.twoRuns;
  const runFee = RULES.secondRunCents ?? RULES.extraDeliveryCents;
  const weeks = RULES.cycleWeeks || 4;
  const availability = new Set(Object.values(ITEMS).filter((i) => i.channel === 'subscription' && i.available && (i.tier === 'standard' || i.tier === 'premium')).map((i) => i.id));
  const template = chefTemplate(availability);

  // First box: the chef's selection for the chosen plan, editable here.
  let box = {}; let boxPlan = null; let boxEdited = false;
  const plan = () => $('input[name="plan"]:checked', signup)?.value;
  const priceBox = () => priceWeek({ included: box }, { rules: RULES, catalog: ITEMS, planId: plan(), availability });
  const boxOk = () => { const p = priceBox(); return !p.errors?.length && p.complete && p.extrasCents === 0; };
  function resetBox() {
    const id = plan(); if (!RULES.plans?.[id]) return;
    if (boxPlan === id && boxEdited) {
      // Keep the customer's picks when switching plan, trimmed to the new plan's size and Premium.
      box = suggestBox({ planId: id, rules: RULES, catalog: ITEMS, previous: box, template, availability }).box;
    } else box = suggestBox({ planId: id, rules: RULES, catalog: ITEMS, previous: {}, template, availability }).box;
    boxPlan = id;
  }
  // Delivery day: one of the schedule's start days, kept every week. A second
  // run goes on another day (the server applies the same rule: pickDeliveryDay).
  const days = [...new Set(slots.map((s) => s.weekday))].sort((a, b) => a - b);
  const dayOpts = $('[data-dayopts]', signup);
  const secondAll = gateOpen ? gate.secondSlots || [] : RULES.secondRunSlots || [];
  const hhmm = (t) => { const [h, m] = t.split(':').map(Number); return `${h % 12 || 12}${m ? `:${String(m).padStart(2, '0')}` : ''} ${h < 12 ? 'a.m.' : 'p.m.'}`; };
  if (days.length > 1) {
    dayOpts.innerHTML = days.map((d, i) => {
      const other = secondAll.filter((s) => s.weekday !== d).map((s) => WEEKDAY_NAMES[s.weekday]);
      return `<label class="runopt"><input type="radio" name="dday" value="${d}"${i ? '' : ' checked'}><span><strong>${WEEKDAY_NAMES[d]}s</strong><small>Around ${hhmm(slots.find((s) => s.weekday === d).time)}${other.length ? ` · with two runs, the second is on ${[...new Set(other)].join(' or ')}` : ''}</small></span></label>`;
    }).join('');
  } else if (days.length === 1) {
    dayOpts.innerHTML = `<p class="small"><strong>Every ${WEEKDAY_NAMES[days[0]]}</strong>, around ${hhmm(slots[0].time)}.</p>`;
  } else $('[data-dayfield]', signup).hidden = true;
  const day = () => Number($('input[name="dday"]:checked', signup)?.value || days[0]);
  const picked = () => (days.length ? pickDeliveryDay(slots, secondAll, day()) : null);
  const twoRadio = $('input[name="runs"][value="2"]', signup);
  if (!twoRunsOk) { twoRadio.disabled = true; $('[data-two-note]', signup).textContent = gateOpen ? 'Not available yet: second-run days aren’t set up.' : 'Available once checkout opens.'; }

  function renderBox() {
    const p = priceBox(); const pl = RULES.plans[plan()];
    const items = Object.entries(box).sort((a, b) => (ITEMS[b[0]].tier === 'premium') - (ITEMS[a[0]].tier === 'premium'));
    $('[data-fb-summary]', signup).innerHTML = `<p class="small"><strong>${p.includedCount} of ${pl.mealsPerWeek} meals</strong> · ${p.premiumIncluded} of ${pl.premiumAllowance} Premium · ${p.extrasCents ? `<span class="is-charge">${cad(p.extrasCents)} extra</span>` : 'nothing extra'}</p>
      <ul class="fb-list">${items.map(([id, q]) => `<li><span>${q} ×</span> ${ITEMS[id].name}${ITEMS[id].tier === 'premium' ? ' <em class="tier tier--premium">Premium</em>' : ''}</li>`).join('')}</ul>
      ${boxOk() ? '' : `<p class="small is-charge" role="alert">${p.includedCount < pl.mealsPerWeek ? `Choose ${pl.mealsPerWeek - p.includedCount} more meal${pl.mealsPerWeek - p.includedCount === 1 ? '' : 's'}.` : 'Keep Premium within your included allowance for the first box.'}</p>`}`;
    const ed = $('[data-fb-editor]', signup);
    if (!ed.hidden) {
      const room = pl.premiumAllowance - p.premiumIncluded; const full = p.includedCount >= pl.mealsPerWeek;
      const est = (i) => { const v = i.nutrition?.verified; const k = v ? i.nutrition.kcal : i.estKcal; const pr = v ? i.nutrition.protein : i.estProtein; const a = v ? '' : '≈';
        return k == null && pr == null ? '' : `<p class="fb-card__macros">${k != null ? `<span>${a}${Math.round(k)} kcal</span>` : ''}${pr != null ? `<span>${a}${Math.round(pr)} g protein</span>` : ''}</p>`; };
      ed.innerHTML = Object.values(ITEMS).filter((i) => availability.has(i.id)).map((i) => `<article class="fb-card${box[i.id] ? ' is-picked' : ''}">
        <div class="fb-card__img">${i.img ? `<img src="${i.img}" alt="${(i.alt || '').replace(/"/g, '&quot;')}" width="320" height="320" loading="lazy">` : ''}${i.tier === 'premium' ? '<em class="tier tier--premium">Premium</em>' : ''}</div>
        <div class="fb-card__body"><h4 class="fb-card__name">${i.name}</h4>${est(i)}
        <div class="qty" data-fb="${i.id}"><button type="button" data-d="-1" aria-label="Remove one ${i.name}"${box[i.id] ? '' : ' disabled'}>−</button><output>${box[i.id] || 0}</output><button type="button" data-d="1" aria-label="Add one ${i.name}"${full || (i.tier === 'premium' && room <= 0) ? ' disabled' : ''}>+</button></div></div></article>`).join('')
        + '<p class="fb-note small muted">Calories and protein are estimates from the recipe (≈), not lab-tested.</p>';
    }
  }
  $('[data-fb-edit]', signup).addEventListener('click', (e) => {
    const ed = $('[data-fb-editor]', signup); ed.hidden = !ed.hidden; e.currentTarget.setAttribute('aria-expanded', String(!ed.hidden));
    e.currentTarget.textContent = ed.hidden ? 'Change meals' : 'Done'; renderBox();
  });
  $('[data-fb-editor]', signup).addEventListener('click', (e) => {
    const b = e.target.closest('[data-fb] button'); if (!b) return;
    const id = b.closest('[data-fb]').dataset.fb; const n = Math.max(0, (box[id] || 0) + Number(b.dataset.d));
    if (n) box[id] = n; else delete box[id];
    boxEdited = true; renderBox(); render();
  });

  const render = () => {
    const sel = $('input[name="plan"]:checked', signup);
    $$('.plan', signup).forEach((p) => p.classList.toggle('plan--rec', p.dataset.plan === sel?.value));
    $$('.plan label.btn', signup).forEach((l) => { const on = l.querySelector('input').checked; l.classList.toggle('btn--lime', on); l.classList.toggle('btn--ghost', !on); });
    const pl = RULES.plans?.[sel?.value]; const lines = $('[data-lines]', signup);
    if (!pl) { lines.innerHTML = ''; return; }
    if (boxPlan !== sel.value) { resetBox(); renderBox(); }
    const two = $('input[name="runs"]:checked', signup)?.value === '2';
    let first = null; let renewal = null;
    const pk = picked();
    if (pk) {
      first = nextSlot(Date.now() + RULES.firstDeliveryMinHours * 3600e3, pk.slots, RULES.timezone);
      renewal = addLocalWeeks(first, weeks, RULES.timezone) - RULES.renewalLeadHours * 3600e3;
    }
    const gift = RULES.giftPlans.includes(sel.value);
    const upgrade = two ? weeks * runFee : 0;
    lines.innerHTML = `
      ${gateOpen && gate.mode === 'test' ? '<div class="is-gift"><span>Test mode: test delivery schedule, not a real delivery</span><span></span></div>' : ''}
      <div><span>${pl.name}, ${weeks} weeks</span><strong>${cad(pl.priceCents)}</strong></div>
      <div><span>${pl.mealsPerWeek} meals a week · ${pl.premiumAllowance} Premium included</span><span>${pl.mealsPerWeek * weeks} meals</span></div>
      ${two ? `<div><span>Second cook &amp; delivery run, every week (${weeks} × ${cad(runFee)}): separate invoice right after checkout</span><span>${cad(upgrade)}</span></div>`
        : '<div><span>One cook &amp; delivery run a week</span><span>Included</span></div>'}
      ${gift ? '<div class="is-gift"><span>Welcome Cheat Meal (first subscription order only)</span><span>CAD 0.00</span></div>' : ''}
      <div><span>First delivery</span><span>${first ? fmtDateTime(first) : 'Confirmed before payment'}</span></div>
      ${pk ? `<div><span>Delivery day</span><span>Every ${WEEKDAY_NAMES[pk.weekday]}${two && pk.secondSlots.length ? ` + ${[...new Set(pk.secondSlots.map((s) => WEEKDAY_NAMES[s.weekday]))].join('/')}` : ''}</span></div>` : ''}
      <div><span>Next billing date</span><span>${renewal ? `${fmtDate(renewal, { year: 'numeric' })} · ${cad(pl.priceCents)}` : 'Shown before payment'}</span></div>
      <div class="is-total"><span>Plan checkout, before tax</span><span data-due-today>${cad(pl.priceCents)}</span></div>
      ${two ? `<div><span>Then: second-run invoice, before tax</span><span>${cad(upgrade)}</span></div>
      <p class="small muted" style="margin:6px 0 0">After checkout, open My Week and pay the ${cad(upgrade)} invoice. Your second-run places are held for 60 minutes; if they fill up before you pay, you get one run and are refunded. Covers this cycle only, not renewed automatically.</p>` : ''}`;
    const msg = $('[data-schedule-msg]', signup); const btn = $('[data-submit]', signup);
    // Test mode: a signed-out visitor may be an invited tester, so offer sign-in; a signed-in
    // account without the test tag is told plainly. The public otherwise sees "not open yet".
    const signInFirst = !DATA.customer && gate?.open && gate.mode === 'test';
    msg.hidden = gateOpen;
    msg.textContent = gateOpen ? '' : signInFirst ? 'Checkout is being tested with invited accounts. If you have one, sign in to continue.'
      : DATA.customer && gate?.open && gate.mode === 'test' ? 'Checkout is being tested and isn’t open for this account yet.'
      : 'Checkout opens once delivery days and areas are confirmed. You can still explore plans and the menu.';
    btn.disabled = !gateOpen && !signInFirst;
    btn.textContent = gateOpen && DATA.customer ? 'Continue to secure checkout' : (gateOpen || signInFirst) ? 'Sign in to continue' : 'Continue to secure checkout';
  };
  signup.addEventListener('change', render); render();
  const REASONS = {
    out_of_area: 'We don’t deliver to this postal code yet.',
    already_subscribed: 'You already have an active plan. Manage it from My Week.',
    test_mode_customer_not_allowed: 'Plan checkout is in testing and not open to the public yet.',
    no_selling_plan: 'This plan can’t be bought right now. Please try again later.',
    first_box_invalid: 'Your first box needs all its meals, within your included Premium.',
    auto_repeat_not_accepted: 'Please accept the automatic weekly box policy.',
    two_runs_unavailable: 'Two runs aren’t available right now. Choose one run a week.',
    second_run_full: 'The kitchen’s second-run days are full for your weeks. Choose one run a week, or try again later.',
    first_delivery_full: 'Your first delivery day is full. Please try again later.',
    delivery_day_required: 'Choose your delivery day.',
    delivery_day_not_offered: 'That delivery day isn’t available. Please choose another.',
  };
  signup.addEventListener('submit', async (e) => {
    e.preventDefault();
    if (!DATA.customer) { location.href = `${window.PC_ROUTES?.login || '/account/login'}?return_to=${encodeURIComponent(location.pathname + location.search)}`; return; }
    const postal = signup.postal; const msg = $('[data-postal-msg]', signup);
    if (!postal.checkValidity()) { msg.textContent = 'Enter a Canadian postal code, like A1A 1A1.'; postal.focus(); return; }
    if (!boxOk()) { msg.textContent = REASONS.first_box_invalid; $('[data-fb-edit]', signup).focus(); return; }
    for (const n of ['autorepeat', 'renewal']) if (!signup[n].checked) { msg.textContent = n === 'autorepeat' ? REASONS.auto_repeat_not_accepted : 'Please confirm how renewal works.'; signup[n].focus(); return; }
    const sel = $('input[name="plan"]:checked', signup);
    const twoRuns = $('input[name="runs"]:checked', signup)?.value === '2';
    const btn = $('[data-submit]', signup); btn.disabled = true; msg.textContent = '';
    try {
      // The server re-checks everything and returns the only lines checkout will accept.
      const r = await fetch('/apps/procalories/api/checkout', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ planId: sel.value, postalCode: postal.value.toUpperCase().replace(/[^A-Z0-9]/g, '').replace(/^(.{3})(.{3})$/, '$1 $2'), firstBox: box, autoRepeatAccepted: true, twoRuns, ...(days.length ? { deliveryDay: day() } : {}) }) });
      const j = await r.json().catch(() => ({}));
      if (!r.ok) {
        const reasons = Array.isArray(j.detail) ? j.detail : [];
        msg.textContent = reasons.map((x) => REASONS[x]).find(Boolean) || 'Checkout is closed right now. Please try again later.';
        btn.disabled = false; return;
      }
      await cartClear();
      await cartAdd([{ ...j.line, properties: { ...j.line.properties, _pc_exclusions: [...ex].join(','), _pc_fallback_agreed: 'yes' } }]);
      location.href = '/checkout';
    } catch (err) { btn.disabled = false; msg.textContent = err.message; }
  });
});

/* ---------- signed-in app ---------- */
if ($('[data-app]')) import('./pc-app.js').then((m) => m.start({ DATA, RULES, ITEMS, priceWeek, suggestBox, autoBox, defaultSplit, chefTemplate, showMeal, openDialog, cart, fmtDate, fmtDateTime, cad }));
